/**
 * Изменилось ли хотябы одно из указанных свойств @see propsNames
 * @param {Object} oldProps
 * @param {Object} newProps
 * @param {...String} propsNames
 * @return {Boolean}
 */
export var some = function some() {
  for (var _len = arguments.length, propsNames = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    propsNames[_key - 2] = arguments[_key];
  }

  var oldProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var newProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return propsNames.some(function (propName) {
    return oldProps[propName] !== newProps[propName];
  });
};

/**
 * Изменились ли все указанные свойства @see propsNames
 * @param {Object} oldProps
 * @param {Object} newProps
 * @param {...String} propsNames
 * @return {Boolean}
 */
export var every = function every() {
  for (var _len2 = arguments.length, propsNames = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    propsNames[_key2 - 2] = arguments[_key2];
  }

  var oldProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var newProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return propsNames.each(function (propName) {
    return oldProps[propName] !== newProps[propName];
  });
};